<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="this.$t('CargoMsg.Cargo_NewTo')"
      width="380px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="90px" label-position="left">
          <el-form-item :label="this.$t('CargoMsg.Cargo_Carrier')">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
              :default-value="form.carrierId||''"
              :callback-params="{key:'carrierId'}"
              @parentCallBack="p => onCompanyChange(p)"
            />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_GenerativeRule')">
            <el-select v-model="form.generativeRule" :disabled="true">
              <el-option
                v-for="(item,index) in generativeRules"
                :key="index"
                :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_ApplicableBranch')" :disabled="false">
            <cargo-advance-select
              no="branchId"
              :select-type="selectTypeNames.basic_data_Office_All"
              :clearable="false"
              filterable
              :default-value="form.branchId||''"
              :cache="false"
              :static-options="officeList"
              :placeholder="' '"
              @parentCallBack="p => handleCompany(p)"
            />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.ApplicableDepartment')">
            <cargo-advance-select
              no="departmentId"
              :select-type="selectTypeNames.basic_data_Department"
              :allow-create="true"
              filterable
              :cache="false"
              :static-options="departmentArray"
              @parentCallBack="p=>{form.department = p.departmentId}"
            />
          </el-form-item>
          <el-form-item v-show="editMblNoMode === 3" :label="this.$t('CargoMsg.Cargo_OrderChannel')">
            <cargo-advance-select
              no="channel"
              :select-type="selectTypeNames.local_cache_SystemConstants$CHANNEL_LIST"
              filterable
              :multiple="true"
              :default-multiple-value="form.channelList"
              tag-name="englishName"
              tag-value="englishName"
              @parentCallBack="p => handleChange(p)"
            />
          </el-form-item>
          <el-form-item :label="this.$t('SeaExport.StartMbl')">
            <el-input v-model="form.startMbl" no="startMbl" />
          </el-form-item>
          <el-form-item :label="this.$t('CargoMsg.Cargo_MblNo')">
            <process-file :file-list="fileList" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button type="primary" @click="downloadHandler">{{ $t('CargoMsg.Cargo_DownLoad_Template') }}</el-button>
          <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect'
import { importFunc } from '@/api/booking/mblManagement'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { cacheKeys, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ProcessFile from '@/views/cargo/v0/SeaExport/MblManagement/components/processFile.vue'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ImportWindow',
  components: { ProcessFile, CargoAdvanceSelect, CargoOwnedBranchSelect, cargoUserSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      checkNoRule: true,
      officeList: [],
      departmentArray: [],
      fileList: [],
      generativeRules: SystemConstants.GENERATIVE_RULES,
      editMblNoMode: 0,
      form: {
        carrierId: 0,
        branchId: 0,
        generativeRule: 2,
        currentBranchId: this.$store.getters.currentOfficeId,
        department: 0,
        channel: '',
        channelList: Array.from(SystemConstants.CHANNEL_LIST, p => p['englishName']),
        startMbl: '',
        file: null
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.editMblNoMode = Number(cache.config.get('EditMblNoMode'))
  },
  mounted() {},
  methods: {
    onCompanyChange(obj) {
      this.form[obj.key] = obj.value
      const branchIds = obj.multipleBranchId ? obj.multipleBranchId.split(',') : []
      const offices = []
      offices.push(obj.branchId)
      offices.push(...branchIds)
      const officesAsNumbers = offices.map(Number)
      this.officeList = getFilterCacheList(basicCacheKeys.basic_data_Office_All, p => officesAsNumbers.includes(p.officeId))
    },
    saveHandler() {
      this.fullscreenLoading = getLoading4Cxt()
      if (!this.form.carrierId || this.form.carrierId === 0) {
        this.$message.warning(this.$t('SeaExport.PleaseSelectCarrier'))
        this.fullscreenLoading.close()
        return
      }
      if (!this.form.branchId) {
        this.$message.warning(this.$t('CargoMsg.PleaseSelectApplicableBranch'))
        this.fullscreenLoading.close()
        return
      }
      const rows = this.fileList.filter(p => !p.fileId)
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseUpload'))
        this.fullscreenLoading.close()
        return
      }
      const fileType = rows[0].fileType
      if (fileType !== 'xls' && fileType !== 'xlsx') {
        this.$message.warning(this.$t('Partners.uploadXLSFormatFile'))
        this.fullscreenLoading.close()
        return
      }
      this.form.file = rows[0].file
      importFunc(this.form).then((res) => {
        const data = res.data
        if (data === 'ok') {
          this.innerVisible = false
          this.$emit('queryList')
        } else if (data.includes('emptyTip')) {
          this.$message.warning(this.$t('CargoMsg.Cargo_EmptyNoTip'))
        } else if (data.includes('prefixTip')) {
          this.$alert(this.$t('CargoMsg.Cargo_ImportStarTip', [data.substring(9)]), this.$t('common.tips.prompt'), {
            dangerouslyUseHTMLString: true,
            showClose: false,
            confirmButtonText: this.$t('common.btn.close'),
            type: 'warning'
          })
        } else if (data.includes('starNoTip')) {
          this.$alert(this.$t('CargoMsg.Cargo_ImportNoTip', [data.substring(9)]), this.$t('common.tips.prompt'), {
            dangerouslyUseHTMLString: true,
            showClose: false,
            confirmButtonText: this.$t('common.btn.close'),
            type: 'warning'
          })
        } else {
          this.$alert(this.$t('CargoMsg.Cargo_AlreadyExistTip', [data]), this.$t('common.tips.prompt'), {
            dangerouslyUseHTMLString: true,
            showClose: false,
            confirmButtonText: this.$t('common.btn.close'),
            type: 'warning'
          })
        }
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    handleChange(p) {
      this.form.channelList = p.englishName
    },
    handleCompany(data) {
      this.form.branchId = data.value
      const officeUuid = data.uuid
      let currentDeptList = []
      if (this.form.branchId && Number(this.form.branchId) === 1) { // 总部的话取所有部门
        currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department_All, null) || []
      } else {
        currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
          return item.officeUuid === officeUuid
        }) || []
      }
      this.departmentArray = currentDeptList
    },
    downloadHandler() {
      ExportUtils.downloadTemplateFile('MblImportDemo.xlsx', 'booking')
    }
  }
}
</script>

